export default __webpack_public_path__ + "c-sharp.8591be54.png";